module.exports = __webpack_public_path__ + "img/symbol_8.4a28433e.png";